export interface Variant {
  id: string;
  sku: string;
  name: string;
  options: Record<string, string>;
  priceCents: string | number;
  compareAtCents: string | number | null;
  costCents: string | number | null;
  barcode: string | null;
  weightGrams: number | null;
  heightCm: number | null;
  widthCm: number | null;
  lengthCm: number | null;
  trackInventory: boolean;
  isDefault: boolean;
}

export interface ProductImage {
  id: string;
  storageKey: string;
  alt: string | null;
  position: number;
  variantId: string | null;
  urls: { w400: string; w1200: string; original: string };
}

export interface Product {
  id: string;
  type: 'PRODUCT' | 'SERVICE';
  status: 'DRAFT' | 'ACTIVE' | 'ARCHIVED';
  name: string;
  slug: string;
  description: string | null;
  categoryId: string | null;
  hasVariants: boolean;
  ncm: string | null;
  cest: string | null;
  origin: number | null;
  unit: string;
  serviceCode: string | null;
  taxProfileId: string | null;
  seo: { title?: string; description?: string };
  featured: boolean;
  /** Preenchido = serviço vendido por assinatura na loja. */
  subscriptionInterval?: 'MONTHLY' | 'WEEKLY' | null;
  /** Preenchido = serviço agendado pela agenda online (por horário ou o dia todo). */
  bookingMode?: 'SLOT' | 'DAY' | null;
  bookingDurationMinutes?: number | null;
  /** Assinatura com agenda: quantos atendimentos por semana ou mês, e como o cliente marca. */
  bookingQuota?: number | null;
  bookingQuotaPeriod?: 'WEEK' | 'MONTH' | null;
  bookingStyles?: ('FIXED' | 'FLEXIBLE')[];
  /** ONLINE: o cliente paga com Pix ao agendar. MANUAL: o dono confirma cada agendamento. */
  bookingPayment?: 'ON_SITE' | 'ONLINE';
  bookingApproval?: 'AUTO' | 'MANUAL';
  priceCents: string | number | null;
  variants: Variant[];
  images: ProductImage[];
  updatedAt: string;
}

export interface CategoryNode {
  id: string;
  name: string;
  slug: string;
  position: number;
  parentId: string | null;
  children: CategoryNode[];
}

export const STATUS_LABEL: Record<Product['status'], string> = { DRAFT: 'Rascunho', ACTIVE: 'À venda', ARCHIVED: 'Arquivado' };
export const STATUS_TONE = { DRAFT: 'neutral', ACTIVE: 'success', ARCHIVED: 'warning' } as const;

/** Achata a árvore com recuo para um <select>. */
export function flattenCategories(nodes: CategoryNode[], depth = 0): { id: string; label: string }[] {
  return nodes.flatMap((n) => [{ id: n.id, label: `${'— '.repeat(depth)}${n.name}` }, ...flattenCategories(n.children, depth + 1)]);
}
